<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{cvCardTitle}}</h4>
          </template>
          <template v-slot:body>
            <p v-show="!propOpenedInModal">{{cvCardSubHeader}}</p>
            <form action="#" v-if="vmgpathConfigFormData && Object.keys(vmgpathConfigFormData).length > 0">
              <div class="form-row">
                  <div class="col-md-12 mb-3">
                    <label for="validationgpc_name">
                      {{cvGpcNameLabel}}</label>
                    <input
                      v-model="vmgpathConfigFormData.gpc_name"
                      type="text"
                      class="form-control"
                      required
                    />
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="validationgpc_workflow_config">
                      {{cvGpcWorkflowConfigLabel}}</label>
                    <textarea
                      v-model="vmgpathConfigFormData.gpc_workflow_config"
                      type="text"
                      class="form-control textarea"
                      required
                    ></textarea>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="validationgpc_workflow_config">{{cvSubsPlanIdLabel}} - <small>{{ vmgpathConfigFormData.subs_plan_id }}</small></label>
                    <!-- Subscription Plan Dropdown -->
                    <multiselect
                      v-model="vmgpathConfigFormData.subs_plan_id"
                      :options="cleanedPlanList"
                      label="label"
                      track-by="id"
                      placeholder="Select Payment Plan"
                      class=""
                      :reduce="plan => plan.id"
                    />
                  </div><!-- Subscription Plan Dropdown -->
                  <div class="col-md-12 mb-3">
                    <label for="validationgpc_report_file">
                      {{cvGpcReportFileLabel}}</label>
                    <input
                      v-model="vmgpathConfigFormData.gpc_report_file"
                      type="text"
                      class="form-control"
                      required
                    />
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="validationgpc_pdt_id">
                      {{cvGpcPdtIdLabel}}</label>
                    <input
                      v-model="vmgpathConfigFormData.gpc_pdt_id"
                      type="text"
                      class="form-control"
                      required
                    />
                </div>
              </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                   <b-spinner label="Spinning"></b-spinner>
                </button>
                <button type="button" class="btn btn-primary" @click="gpcEdit()">{{cvSubmitBtn}}</button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { GPathConfig } from "../../../FackApi/api/GpathConfig"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"
import { SubscriptionPlans } from "../../../FackApi/api/Subscription/subscriptionPlan"
import Multiselect from "vue-multiselect"

export default {
  name: "gpathConfigEdit",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propgpathConfigObj: {
      type: Object,
      default: function () {
        return {
          "gpc_name": "",
          "gpc_workflow_config": "",
          "gpc_report_file": "",
          "gpc_pdt_id": "",
          "subs_plan_id": ""
        }
      }
    }
  },
  data () {
    return {
      cvCardTitle: "Edit GPath Product Config",
      cvCardSubHeader: "Edit GPath Product Config",
      cvSubmitBtn: "Edit",
      cvSubsPlanIdLabel: "Subscription Plan Id",
      cvGpcNameLabel: "GPath Product Config Name",
      cvGpcWorkflowConfigLabel: "GPath Product Workflow Config",
      cvGpcReportFileLabel: "GPath Product Report File (Eg. .ejs)",
      cvGpcPdtIdLabel: "GPath Product Id",
      showToast: false,
      cvLoadingStatus: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "GPath Product Config Updated",
      vmgpathConfigFormData: {},
      planIdList: [],
      cleanedPlanList: []
    }
  },
  components: {
    Multiselect
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    socialvue.index()
    this.gpcView()
    this.getPlanNames()
  },
  methods: {
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmgpathConfigFormData) {
          if (!this.vmgpathConfigFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
        return null
      }
    },
    /**
     * gpcView
     */
    async gpcView () {
      try {
        if (this.propOpenedInModal) {
          this.vmgpathConfigFormData = this.propgpathConfigObj
        }
        else {
          let gpcId = this.$route.params.gpc_id
          let gpcViewResp = await GPathConfig.gpcView(this, gpcId)

          if (gpcViewResp && gpcViewResp.resp_status) {
            this.vmgpathConfigFormData = gpcViewResp.resp_data.data
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at gpcView() and Exception:", err.message)
      }
    },
    /**
     * gpcEdit
     */
    async gpcEdit () {
      try {
        // if (!this.validate()) {
        //   return false
        // }
        this.cvLoadingStatus = true
        this.vmgpathConfigFormData.subs_plan_id = this.vmgpathConfigFormData.subs_plan_id
        let gpcAddResp = await GPathConfig.gpcEdit(this, this.vmgpathConfigFormData)
        await ApiResponse.responseMessageDisplay(this, gpcAddResp)

        if (gpcAddResp && !gpcAddResp.resp_status) {
          return false
        }

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitClosegpath_configEditModal", this.vmgpathConfigFormData)
        }
      }
      catch (err) {
        console.error("Exception occurred at gpcEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * getPlanNames
     */
    async getPlanNames () {
      try {
        const subsPlanListResp = await SubscriptionPlans.subscriptionPlanList(this)
        if (subsPlanListResp.resp_status) {
          this.planIdList = subsPlanListResp.resp_data.data
          this.cleanedPlanList = this.planIdList.map(plan => ({
            id: plan.subs_plan_id,
            label: `${plan.subs_plan_name} (${plan.subs_plan_id})`
          }))
        }
      }
      catch (err) {
        console.error("Error in getPlanNames ", err)
      }
    }
  }
}
</script>
<style lang="css">
  textarea{
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
</style>
